import React from 'react';
import { Box } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { EmissionAllocation } from 'api';
import { CustomMaterialTable, EditButton } from 'components';
import { DeleteAllocationButton } from '../deleteAllocationButton';

interface AllocationSetupsTableProps {
    data: EmissionAllocation[];
    columns: MRT_ColumnDef<EmissionAllocation>[];
    onViewDetails: (allocationId: number) => void;
}

export const AllocationSetupsTable = ({ data, columns, onViewDetails }: AllocationSetupsTableProps) => (
    <Box sx={{ mt: '20px' }}>
        {data?.length > 0 ? (
            <CustomMaterialTable
                data={data}
                columns={columns}
                enablePagination={false}
                enableRowActions
                enableRowVirtualization
                positionActionsColumn="last"
                renderRowActions={({ row }: any) => (
                    <div>
                        <EditButton onClick={() => onViewDetails(row.original.allocationId)} tooltipTitle="View Details" />
                        <DeleteAllocationButton allocationId={row.original.allocationId} />
                    </div>
                )}
                getRowId={(row) => String(row.allocationId)}
                muiTableContainerProps={{
                    sx: {
                        height: 'calc(100vh - 305px)',
                    },
                }}
                muiTableProps={{
                    sx: {
                        tableLayout: 'auto',
                        whiteSpace: 'nowrap',
                    },
                }}
            />
        ) : (
            <Box sx={{ textAlign: 'center', padding: '20px', color: 'text.secondary' }}>
                No allocation setups available.
            </Box>
        )}
    </Box>
)